export default "__VITE_ASSET__C9shsQ27__"